import { Injectable } from '@angular/core';

import { RolePermissionsService } from '../services/role-permissions.service';

@Injectable()
export class ViewerAndAboveGuard {
	constructor(private permissionsService: RolePermissionsService) {}

	public canActivate(): boolean {
		return this.permissionsService.isViewerAndAbove();
	}
}
